// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"f74f365e","453":"d855a71b"}[chunkId] + ".chunk.js";
};